export default __webpack_public_path__ + "static/media/Dell.b3230ae5.png";